
/**
 * AS-11681 — bulk delete for the PO list. The list only lets draft/canceled
 * rows be ticked (selectable-key="isDeletable"); the server re-checks each id
 * and reports refusals, which the snackbar names.
 */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { PurchaseOrderModel } from '@/models/purchase_order';
import { PurchaseOrders } from '@/collections/purchase_orders';
import { summarizeBulkDelete } from '@/views/purchase-order/poBulkDelete';
import { extractApiErrorMessage } from '@/services/http';
import { FloatingBarInsetReservation } from '@/services/floatingActionsBarInset';
import { EventBus } from '@/main';

@Component({})
export default class PurchaseOrderBulkDeleteBar extends Vue {
  @Prop({ default: () => [] }) public readonly selected!: PurchaseOrderModel[];

  private confirmOpen = false;
  private deleting = false;
  private insetReservation = new FloatingBarInsetReservation();

  public get poNumbers(): string {
    return this.selected.map((po) => po.poNumber).join(', ');
  }

  public async onConfirm(): Promise<void> {
    const ids = this.selected.filter((po) => po.isDeletable).map((po) => po.id as number);
    if (ids.length === 0) { return; }

    this.deleting = true;
    try {
      const result = await new PurchaseOrders().bulkDelete(ids);
      const summary = summarizeBulkDelete(result, this.selected as any[]);
      EventBus.$emit('show-snackbar', { message: summary.message, color: summary.color });
      this.confirmOpen = false;
      this.$emit('deleted');
    } catch (error: any) {
      EventBus.$emit('show-snackbar', {
        message: await extractApiErrorMessage(error, 'Failed to delete purchase orders'),
        color: 'error',
      });
      this.confirmOpen = false;
    } finally {
      this.deleting = false;
    }
  }

  @Watch('selected', { immediate: true })
  private onSelectedChange(selected: PurchaseOrderModel[]): void {
    this.insetReservation.syncFromCount(selected.length);
  }

  private beforeDestroy(): void {
    this.insetReservation.release();
  }
}
